// extracted by mini-css-extract-plugin
export default {"baselineComparisonCard":"BaselineComparisonCard_baselineComparisonCard__EX-Cq","title":"BaselineComparisonCard_title__Ddxlw"};